import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

import Image from "./Image";

const CurvesPlot = () => {
  const singleCurveSVG = useSelector(
    (state: RootState) => state.app.singleCurveSVG
  );

  return <Image svgB64={singleCurveSVG} />;
};

export default CurvesPlot;
